<template>
    <div class='order-form-item' :class="{'show-bottom-dashed-border': showDashedBottomLine}"
        :style="{ height: height, lineHeight: lineHeight || height }">
        <div class="order-form-item-left">
            <slot name="left"/>
            <span>{{ leftContent }}</span>
        </div>
        <div class="order-form-item-right">
            <slot name="right"/>
            <span>{{ rightContent }}</span>
        </div>
    </div>
</template>

<script lang='ts'>
export default {
    props: {
        showDashedBottomLine: {
            type: Boolean,
            default: true
        },
        height: {
            type: String,
            default: '44px'
        },
        lineHeight: {
            type: [String, Number],
            default: '44px',
        },
        leftContent: String,
        rightContent: String
    }
}
</script>

<style lang="scss" scoped>
.order-form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    padding: 0 12px;
    font-size: 14px;
    color: #333;

    &:hover {
        background: #f5f7fa;
    }

    &.show-bottom-dashed-border {
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: 12px;
            right: 12px;
            bottom: -0.5px;
            border-bottom: 1px dashed #EBEBEB;
        }
    }
}
</style>
